const { addActions } = require('js-data-http')
const { Schema, Mapper } = require('js-data')

// Valid Schema according to the http://json-schema.org/ v4 specification.
const landing_page_schema = new Schema({
  title: "Landing Page",
  description: "Landing page schema for validation",
  required: ["name"],
  type: "object",
  properties: {
    name: {
      type: "string",
      minLength: 1,
      maxLength: 255
    }
  }
})

let mapper_options = {
  name: 'landing_page',
  endpoint: 'landing_pages',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      campaign: {
        localKey: 'campaign_id',
        localField: 'campaign'
      },
      template: {
        localKey: 'template_id',
        localField: 'template'
      }
    },
    hasMany: {
      landing_page_widget: {
        foreignKey: 'landing_page_id',
        localField: 'landing_page_widgets'
      }
    }
  }
}

module.exports = (store) => {
  let mapper = store.defineMapper('landing_page', mapper_options)
  addActions({
    reorder_widgets: {
      pathname: 'widgets/bulk_update',
      method: 'PUT'
    },
    add_widget: {
      pathname: 'widgets',
      method: 'POST'
    }
  })(mapper)
}
